import {Component, inject, Input} from '@angular/core';
import {LinkWithoutHrefDirective} from '@icz/angular-essentials';
import {ObjectAssociationAlertComponent} from '../object-association-alert/object-association-alert.component';
import {TranslateParser, TranslatePipe, TranslateService} from '@ngx-translate/core';
import {EntityType, ObjectClass} from '|api/commons';
import {CaseFileElasticDto} from '|api/elastic';
import {Router} from '@angular/router';
import {getSuperclassEntityType} from '|shared';
import {ApplicationRoute, CaseFileDetailRoute, createAbsoluteRoute, DocumentsRoute} from '|ui-essl-core';

@Component({
  selector: 'icz-case-file-association-alert',
  templateUrl: './case-file-association-alert.component.html',
  styleUrl: './case-file-association-alert.component.scss',
  imports: [LinkWithoutHrefDirective, ObjectAssociationAlertComponent, TranslatePipe],
})
export class CaseFileAssociationAlertComponent {

  private router = inject(Router);
  private translateParser = inject(TranslateParser);
  private translateService = inject(TranslateService);

  @Input({required:true})
  parentEntityType!: EntityType;
  @Input({required:true})
  caseFileInfo: Nullable<CaseFileElasticDto>;
  @Input({required:true})
  isCaseFileInfoUnavailable = false;

  get heading() {
    return this.translateParser.interpolate(
      this.translateService.instant('{{entityType}} je vložen do typového spisu'),
      {
        entityType: this.translateService.instant(`en.entityType.${getSuperclassEntityType(this.parentEntityType)}`),
      }
    )!;
  }

  openCaseFileDetail(caseFileInfo: CaseFileElasticDto) {
    this.router.navigateByUrl(createAbsoluteRoute(
      ApplicationRoute.DOCUMENTS,
      DocumentsRoute.CASE_FILE,
      caseFileInfo.id!
    ));
  }

  openCaseFilePartDetail(caseFileInfo: CaseFileElasticDto) {
    this.router.navigateByUrl(createAbsoluteRoute(
      ApplicationRoute.DOCUMENTS,
      DocumentsRoute.CASE_FILE,
      caseFileInfo.id!,
      CaseFileDetailRoute.PARTS,
      caseFileInfo.partId!
    ));
  }

  protected readonly ObjectClass = ObjectClass;

}
